import {SUPPRESSED_COOKIE_BANNER_PATHS} from '../consts';

function normalizePathname(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith('/')) {
    return pathname.slice(0, -1);
  }

  return pathname;
}

export function isCookieBannerSuppressedPath(pathname: string): boolean {
  return SUPPRESSED_COOKIE_BANNER_PATHS.has(normalizePathname(pathname));
}
